module.exports = __webpack_public_path__ + "media/images/logo-037e7277988e30efe266d7bea42a04f3.png";